import * as React from 'react';
import styles from './index.less';
import Uploading from '../Uploading';
import UploadSuccess from '../UploadSuccess';
import UploadCancel from '../UploadCancel';
import UploadSameName from '../UploadSameName';
import UploadFailed from '../UploadFailed';
import { Canceler } from 'axios';
import { FUtil, FServiceAPI } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
// import { getFilesSha1Info } from '@/utils/service';
// import * as AHooks from 'ahooks';
// import type { RcFile } from 'antd';
import { ListItem, UploadStatus } from '../useStorageUploadTasks';
interface TaskProps {
  task: ListItem;
  on_Uploading_Cancel?: () => void;
  on_Canceled_ReUpload?: () => void;
  on_SameName_ReUpload?: () => void;
  on_Failed_ReUpload?: () => void;
}

function Task({
  task,
  on_Uploading_Cancel,
  on_Canceled_ReUpload,
  on_SameName_ReUpload,
  on_Failed_ReUpload,
}: TaskProps) {
  return (
    <div className={styles.taskItem}>
      <div className={styles.taskInfo}>
        <FComponentsLib.FContentText text={task.name} singleRow={true} />
        <div style={{ height: 2 }} />
        <FComponentsLib.FContentText
          text={FUtil.Format.humanizeSize(task.file.size)}
        />
      </div>

      {task.status === UploadStatus.LOADING && (
        <FComponentsLib.FTextBtn>加载中...</FComponentsLib.FTextBtn>
      )}

      {task.status === UploadStatus.PENDING && (
        <FComponentsLib.FTextBtn>等待中...</FComponentsLib.FTextBtn>
      )}

      {task.status === UploadStatus.UPLOADING && (
        <Uploading
          progress={task.progress}
          cancel={() => {
            on_Uploading_Cancel?.();
          }}
        />
      )}
      {task.status === UploadStatus.COMPLETED && <UploadSuccess />}
      {task.status === UploadStatus.CANCELED && (
        <UploadCancel
          onClick={async () => {
            on_Canceled_ReUpload?.();
          }}
        />
      )}
      {task.status === UploadStatus.SAME_NAME && (
        <UploadSameName
          onClick={async () => {
            on_SameName_ReUpload?.();
            // await startUploadFile();
          }}
        />
      )}
      {task.status === UploadStatus.FAILED && (
        <UploadFailed
          onClick={async () => {
            on_Failed_ReUpload?.();
          }}
        />
      )}
    </div>
  );
}

export default Task;

// const data = [
//   {
//     key: 'fileSize',
//     name: '文件大小',
//     description: '文件占用的存储',
//     value: 1024,
//     valueUnit: 'b',
//     valueDisplay: '1kb',
//   },
// ];
